import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUpdateOrganizationalUnitRequestFailure() {
      return getState().request.isFailure;
    },
    isUpdateOrganizationalUnitRequestPending() {
      return getState().request.isPending;
    },
    isUpdateOrganizationalUnitRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
